module.exports = __webpack_public_path__ + "img/24.8cfac342.png";